import React, {useEffect, useState, useRef, useContext} from "react";
import BasicView from "../../components/BasicView";
import HeadsVies from "../../styles/HeadsVies";
import {SecondView, TitleSection} from "../../styles/HeadView";
import {Content} from "../../styles/GlobalStyles";
import {TypeTitle} from "../../styles/Products";
import Color from "../../assets/Colors";
import Offer from "../../styles/Offer";
import DownArrow from "../../components/DownArrow";
import scrollToRef from "../../constants/DownAction";
import {CoursesContext} from "../../context/CoursesContext";
import {LoadComponet} from "../../components/loaders/Loader";
import parse from "html-react-parser";
import {HeadersContext} from "../../context/HeadersContext";

export default function CertifiedPrime() {
   const {getHeader, primeHeader} = useContext(HeadersContext);
   const {primeData, getPrime, primeMaster, getPrimeMaster} = useContext(CoursesContext);
   const CertificadoPrimeDomecq = useRef(null);
   const [isMobile, setMobile] = useState(false);
   const goTo = () => scrollToRef(CertificadoPrimeDomecq);

   useEffect(() => {
      getPrime();
      getPrimeMaster();
      getHeader("Prime");
      setMobile(window.screen.width <= 500);
   }, []);

   if (primeHeader.isLoading) return <LoadComponet isVisible={true} />;
   return (
      <BasicView
         imageBack={`http://domecqapi.trebolbit.com/${isMobile ? primeHeader.pathImageWebMobile : primeHeader.pathImageWebDesktop}`}
      >
         <HeadsVies
            type={2}
            title={
               isMobile ? (
                  "Certificado prime domecq"
               ) : (
                  <span>
                     Certificado <br /> prime domecq
                  </span>
               )
            }
            description="Un conjunto de certificaciones creadas para aquellos interesados que cuenten con 3 años de
            experiencia en adelante, y quieran perfeccionar técnicas, aprender sobre tendencias y conocer todo
            sobre nuevos lanzamientos."
            // description={primeHeader.description ? parse(primeHeader.description) : "Descripción"}
         />
         <SecondView>
            <DownArrow goTo={goTo} />
            <Content ref={CertificadoPrimeDomecq}>
               <TitleSection className="stylesPrime">
                  <img src={require("../../assets/icons/essential_offer.png")} alt="offer" className="icon grand" />
                  <TypeTitle size="1.6em" color={Color.primary}>
                     Oferta academica
                  </TypeTitle>
               </TitleSection>
            </Content>
            {primeData.isLoading ? (
               <LoadComponet isVisible={true} />
            ) : (
               <Content>
                  <Offer data={primeData.offer} pathName="certificado_prime" />
               </Content>
            )}

            <Content>
               <TitleSection className="stylesPrime">
                  <img src={require("../../assets/icons/masterclassIcon.png")} alt="offer" className="icon grand2" />
                  <TypeTitle size="1.6em" color={Color.primary}>
                     Masterclasses
                  </TypeTitle>
               </TitleSection>
            </Content>
            {primeMaster.isLoading ? (
               <LoadComponet isVisible={true} />
            ) : (
               <Content>
                  <Offer data={primeMaster.offer} pathName="masterclass" />
               </Content>
            )}
         </SecondView>
      </BasicView>
   );
}
